module.exports = __webpack_public_path__ + "static/a-xx-038-art-0c24c7ea85307a61df9e577d4a489b57.jpg";